module.exports = __webpack_public_path__ + "static/img/M2-S-218-1.bfeccb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module2/M2-S-218-1.png
// module id = 583
// module chunks = 0